import { ReactNode } from 'react';
import { Button, Modal, ModalBody } from 'reactstrap';

export type ConfirmModalProps = {
    isOpen: boolean;
    toggle: () => void;
    title: string;
    message?: string;
    handleConfirm: () => void;
    saving: boolean;
    isDeleting?: boolean;
    // Extra controls to answer before confirming, e.g. the Event/Sale choice
    // the fundraiser copy modal asks for.
    children?: ReactNode;
    confirmDisabled?: boolean;
    // Overrides the Ok/Delete button text and color, for a confirm that
    // isn't a delete but still deserves a pause
    confirmLabel?: string;
    confirmColor?: string;
};

export const ConfirmModal = (props: ConfirmModalProps) => {
    const {
        isOpen,
        toggle,
        handleConfirm,
        title,
        message,
        saving,
        isDeleting,
        children,
        confirmDisabled,
        confirmLabel,
        confirmColor,
    } = props;

    return (
        <Modal centered isOpen={isOpen} toggle={toggle}>
            <ModalBody>
                <h3 className='text-modal modal__title'>{title}</h3>
                {message && message.length > 0 && (
                    <p style={{ marginBottom: children ? '20px' : '40px' }}>
                        {message}
                    </p>
                )}
                {children && (
                    <div style={{ marginBottom: '40px' }}>{children}</div>
                )}
                <Button color='outline-dark' onClick={toggle} disabled={saving}>
                    Cancel
                </Button>
                <Button
                    color={confirmColor || (isDeleting ? 'danger' : 'primary')}
                    onClick={handleConfirm}
                    disabled={saving || confirmDisabled}
                >
                    {saving
                        ? `Saving`
                        : confirmLabel || (isDeleting ? `Delete` : `Ok`)}
                </Button>
            </ModalBody>
        </Modal>
    );
};
